export default "__VITE_ASSET__Dzp$5AjF__"